import { Table, Space, Button, Popconfirm, Typography, Tag, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useState } from "react";

const { Text } = Typography;

const formatNumber = (value) =>
  new Intl.NumberFormat("es-CO").format(Number(value || 0));

export default function EntregasTable({ data = [], loading, selectedRows, setSelectedRows, onDelete, onEdit, permissionDelete, permissionUpdate }) {

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const rowSelection = {
    selectedRowKeys: selectedRows.map((r) => r.oid),
    onChange: (_, selectedRowsData) => {
      setSelectedRows(selectedRowsData);
    }
  };

  const columns = [
    {
      title: "Participante",
      width: 220,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>
            {record.nombre_participante}
          </Text>
          <Text type="secondary">
            CC {record.numero_identificacion}
          </Text>
        </Space>
      )
    },
    {
      title: "Producto",
      width: 350,
      render: (_, record) => (
        <Tooltip title={record.nombre_producto}>
          <Space direction="vertical" size={0}>
            <Text strong ellipsis>
              {record.nombre_producto}
            </Text>
            <Text
              type="secondary"
              style={{ fontSize: 12 }}
              ellipsis
            >
              {record.tipo_producto}
            </Text>
          </Space>
        </Tooltip>
      )
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      width: 100,
      align: "center",
      render: (value) => (
        <Text strong>
          {formatNumber(value)}
        </Text>
      )
    },
    {
      title: "Ubicación",
      width: 160,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>
            {record.municipio}
          </Text>
          <Text type="secondary">
            {record.departamento}
          </Text>
        </Space>
      )
    },
    {
      title: "Proyecto",
      width: 350,
      render: (_, record) => (
        <Space direction="horizontal" size={0}>
          <Tag color="blue">
            {record.codigo}
          </Tag>
          <Text
            type="secondary"
            ellipsis
          >
            {record.proyecto}
          </Text>
        </Space>
      )
    },
    {
      title: "Tipo",
      dataIndex: "tipo_entrega_texto",
      width: 120,
      align: "center",
      render: (value) => (
        <Tag color={value === "Participante" ? "blue" : "green"}>
          {value}
        </Tag>
      )
    },
    {
      title: "Fecha",
      dataIndex: "fecha_entrega",
      width: 130,
      render: (value) =>
        dayjs(value).format("DD MMM YYYY")
    },
    {
      title: "Acciones",
      fixed: "right",
      align: "center",
      width: 100,
      render: (_, record) => (
        <Space>

          {permissionUpdate && (
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
            />
          )}
          {permissionDelete && (
            <Popconfirm
              title="Eliminar entrega"
              description="¿Seguro que deseas eliminar este registro?"
              onConfirm={() => onDelete(record)}
              okText="Sí"
              cancelText="No"
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="oid"
      bordered
      loading={loading}
      columns={columns}
      dataSource={data}
      rowSelection={permissionDelete ? rowSelection : undefined}
      scroll={{ x: 1200 }}
      onChange={handleTableChange}
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        showTotal: (total) => `Total registros: ${total}`
      }}
    />
  );
}